// React
import React from 'react';
import { Col, Row, Button } from 'reactstrap';

export const BillsToReciveFilters = ({ filter, setFilter }) => {
  return (
    <Row className="mb-3">
      <Col md={12}>
        <div className="d-flex ms-3 gap-3 flex-wrap">
          <Button
            color="success"
            outline
            className="d-block btn-soft-success border-0 rounded-pill"
            active={!filter}
            onClick={() => setFilter('')}
          >
            Todos
          </Button>

          <Button
            color="success"
            outline
            className="d-block btn-soft-success border-0 rounded-pill"
            active={filter === 'pendent'}
            onClick={() => setFilter('pendent')}
          >
            Pendentes
          </Button>

          <Button
            color="success"
            outline
            className="d-block btn-soft-success border-0 rounded-pill"
            active={filter === 'overdue'}
            onClick={() => setFilter('overdue')}
          >
            Vencidos
          </Button>
          <Button
            color="success"
            outline
            className="d-block btn-soft-success border-0 rounded-pill"
            active={filter === 'paid'}
            onClick={() => setFilter('paid')}
          >
            Confirmados
          </Button>
        </div>
      </Col>
    </Row>
  );
};
